import UserPermissions from '../../../../permissions/constants/userPermissions';
import { VisitAddedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import { transformVisitAddedToPlanningAction } from '../../utils/transformVisitsAddedToPlanningAction';

export default ({ store, visit }: VisitAddedDtoModelType) => async () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  const hasUnscheduledPermission = rootStore.account.hasPermission(UserPermissions.CREATE_VISITS);

  if (visit && projectId && hasUnscheduledPermission) {
    rootStore.planningActions.setMapBoundsBasedOnAction(transformVisitAddedToPlanningAction(visit));
  }
};
